import { render, staticRenderFns } from "./WasteExchangeBedView.vue?vue&type=template&id=79d6111c&scoped=true&"
import script from "./WasteExchangeBedView.vue?vue&type=script&lang=js&"
export * from "./WasteExchangeBedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d6111c",
  null
  
)

export default component.exports